import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredString,
    SYNC_UPDATE_VALIDATION_SCHEMA,
    timestamp,
} from './common';

export const createUserAnswerAddSchema = () =>
    z
        .object({
            id: requiredString,
            user_id: requiredString,
            answer_id: requiredString,
            created_at: timestamp,
            updated_at: timestamp,
        })
        .strict();

export const createUserAnswerUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createUserAnswerAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.user_answers,
    );

export const createUserAnswerDeleteSchema = () => createDeleteSchema();

export const createUserAnswerSchemas = () => ({
    add: createUserAnswerAddSchema(),
    update: createUserAnswerUpdateSchema(),
    delete: createUserAnswerDeleteSchema(),
});

export const userAnswerRawRecordSchema = createUserAnswerAddSchema();
